import { UnleashClient } from '@unleash/proxy-client-react';
import { unleashProxyConfig } from './unleash-proxy';

export const unleashClient = new UnleashClient(unleashProxyConfig);

if (typeof window !== 'undefined' && window.navigator.onLine) {
  unleashClient.start();
}
